export default __webpack_public_path__ + "81414763e302b31363da5246bdf94cd2.svg";